import { AmplifyPatch } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "providers/logger";

const updateVerificationCallODI = async (
  authKey: string,
  prospectId: string,
  proposalId: string,
  odiValue: string
) => {
  const updateVerificationCallODIResponse = await AmplifyPatch<{
    result: {
      id: string;
      success: boolean;
      errors: string[];
    }[];
  }>(
    "Update Verification Call ODI",
    "OfferExpApi",
    `/prospect/${prospectId}/proposals/${proposalId}/verification-call-odi`,
    {
      headers: {
        Authorization: `Bearer ${authKey}`,
      },
      body: {
        ODIValue: odiValue,
      },
    },
    logger
  );

  const formattedResponse = updateVerificationCallODIResponse.result[0];

  return formattedResponse;
};

export { updateVerificationCallODI };
